export function legacyPatternsMerger(a, b) {
    return a === b ? a : `(?=${a})(?=${b})`;
}
export function simplePatternsMerger(a, b) {
    return a === b ? a : `^(?=.*(?:${a}))(?=.*(?:${b})).*$`;
}
//# sourceMappingURL=patterns.js.map